/**
 * Grid Controller.
 * This controller should be used for interaction with the grid.
 */
angular.module('cfn').controller('cfnGridController', cfnGridController);

cfnGridController.$inject = [
  '$scope',
  '$element',
  '$filter',
  '$log',
  'cfnGridDefaults',
  '$timeout'
];
function cfnGridController(
  $scope,
  $element,
  $filter,
  $log,
  cfnGridDefaults,
  $timeout
) {
  var ctrl = this;

  app.startPerfTimer('cfnGridInitController');

  if (
    !$scope.defaultsortdirection &&
    !$scope.defaultsortdirection == 'asc' &&
    !$scope.defaultsortdirection == 'desc'
  ) {
    $log.warn('wrong parameter: deafultsortdirection');
  }

  $scope.gridController = $scope.controller = this;
  $scope.columns = $scope.columns = [];

  ctrl.refresh = function() {
    $timeout(function() {
      $scope.width = $element.parent().width();
      $scope.calculateWidths($scope.width);
    });
  };

  ctrl.setMultiSelectable = function(multi) {
    $scope.multiselection = multi;
  };

  ctrl.setFilter = function(column, filterText, doImmediately) {
    $scope.view.filters[column] = filterText;

    if (doImmediately) {
      $scope.view.applyFilterImmediately = true;
    }
  };

  ctrl.getFilterOptions = function(colName) {
    //this is set by FnHacks (wtf?)
    if ($scope.view.filterArrays) return $scope.view.filterArrays[colName];
    return undefined;
  };

  ctrl.setFilterOptions = function(colName, values) {
    //this is set by FnHacks (wtf?)
    if ($scope.view.filterArrays) {
      $scope.view.filterArrays[colName] = values;
    }
  };

  ctrl.resetFilters = function() {
    $scope.view.filters = {};
    $scope.view.applyFilterImmediately = true;
  };

  ctrl.getFilters = function() {
    return $scope.view.filters;
  };

  ctrl.getSortedColumns = function() {
    return $scope.$cfnGridSorting.getSortedColumns();
  };

  ctrl.setSortedColumns = function(sortingData) {
    _.each(sortingData, function(sortingColumn) {
      sortingColumn.sorted = true;
      sortingColumn.column = $scope.columnsByName[sortingColumn.col];
    });

    return $scope.$cfnGridSorting.setSortedColumns(sortingData);
  };
  ctrl.resetSortedColumns = function() {
    var emptySortingData = [];
    _.each($scope.columns, function(column) {
      emptySortingData.push({ column: column, sorted: false });
    });
    return $scope.$cfnGridSorting.setSortedColumns(emptySortingData);
  };

  ctrl.setSelectedRowByObj = function(obj) {
    $scope.setSelectedRowByObj(obj);
  };

  /*
   sets the row selection by id
   */
  ctrl.setSelectedRowById = function(id) {
    $scope.selectInViewById(id);
  };

  ctrl.clearSelection = function() {
    $scope.clearSelection();
  };

  /* allows to set the current selection hash of the grid */
  ctrl.setSelectionByHash = function(selectionHash) {
    $scope.selected = {};

    $.each($scope.ngModel, function(k, v) {
      if (selectionHash[v.id]) {
        $scope.selected[v.id] = v;
        v.$cfngrid_selected = true;
      }
    });
    $scope.updateView($scope.datasource());
  };

  ctrl.getSelectedHash = function(elements) {
    return $scope.selected;
  };

  /* sets the internal selection hash*/
  ctrl.setSelectedHash = function(elements) {
    $scope.selected = elements;
  };

  /* sets the internal selection hash*/
  ctrl.getFilteredData = function() {
    return $scope.filterdData;
  };

  /* return the values of the filters */
  ctrl.getFilters = function() {
    return $scope.view.filters;
  };

  /* adds Item (optional: before or after a certain object) */
  ctrl.addItem = function(item, atObjPosition, addMode) {
    var position = atObjPosition
      ? $scope.filterdData.indexOf(atObjPosition)
      : 0;

    console.log('add', atObjPosition);

    $scope.$cfnGridView.deactivateSortOnce();

    $scope.ngModel.push(item);

    if (addMode === 'AFTER') {
      $scope.filterdData.splice(position + 1, 0, item);
    } else {
      $scope.filterdData.splice(position, 0, item);
    }
  };

  /* replaces Item */
  ctrl.replaceItem = function(newItem, oldItem) {
    var indexOfNgModel = $scope.ngModel.indexOf(oldItem),
      indexOfFilterdData = $scope.filterdData.indexOf(oldItem),
      indexOfViewData = $scope.viewData.indexOf(oldItem);

    $scope.ngModel[indexOfNgModel] = newItem;
    $scope.filterdData[indexOfFilterdData] = newItem;
    $scope.viewData[indexOfViewData] = newItem;
  };

  // deprecated functions that compatible to the old grid
  cfnGridCompatibility.addControllerFunctions(
    ctrl,
    $scope,
    $element,
    $filter,
    $log
  );

  // internal functions

  // this function is used by the column directive to add columns
  var dbg_usedColumnNames = {};
  this._addColumn = function(column) {
    var isHideColumn =
      column.showif === 'false' ||
      (column.showifModule && !app.hasModule(column.showifModule));

    if (isHideColumn) return;

    if (column.name) {
      if (dbg_usedColumnNames[column.name]) {
        console.error(
          'column name ' + column.name + ' is used multiple times!'
        );
      }
      dbg_usedColumnNames[column.name] = true;
    }

    // copy to not copy the whole scope
    column = $.extend(false, cfnGridDefaults.defaults.column, column);
    // default parameter for angular

    $scope.columns.push(column);
  };
  app.stopPerfTimer('cfnGridInitController');
}
